import { captureException } from "services/captureException";

export function withNewValue<T>(
	newValue: T | undefined,
	handler: (value: T) => void
) {
	if (!newValue) {
		throw captureException(new Error("No new value"), {
			evtType: "noNewValue"
		});
	}
	handler(newValue);
}
